import { styled } from "@mui/material/styles";

const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  [theme.breakpoints.down("md")]: {
    padding: "8px",
  },
}));
const Column = styled("div")(({ theme }) => ({
  margin: "auto",
  marginBottom: "30px",
  borderRadius: "20px",
  minHeight: "550px",
  padding: "15px",
  width: "100%",
  maxWidth: "550px",
  background: "#F3F3F3",
  [theme.breakpoints.down("sm")]: {
    minHeight: "500px",
  },
}));
const NonContacts = styled("div")(({ theme }) => ({
  margin: "auto",
  marginBottom: "30px",
  borderRadius: "20px",
  padding: "15px",
  width: "100%",
  maxWidth: "550px",
}));
const Field = styled("p")(({ theme }) => ({
  fontSize: "1.5rem",
  textTransform: "uppercase",
  fontWeight: "450",
  color: "#FF0000",
}));
const FieldInfo = styled("p")(({ theme }) => ({
  fontSize: "1.2rem",
  textTransform: "uppercase",
  fontWeight: "300",
  color: "grey",
}));
const Button = styled("button")((props) => ({
  width: "100%",
  ...(props.deleted === "true"
    ? { backgroundColor: "#CB8585" }
    : { backgroundColor: "#FF0000" }),
  // backgroundColor: "#FF0000",
  textAlign: "center",
  padding: "15px",
  border: "0px",
  color: "white",
  maxWidth: "25rem",
  "&:hover": {
    backgroundColor: "#ffcdd2",
    opacity: [0.9, 0.8, 0.7],
    color: "black",
  },
  "&:focus": {
    outline: "0 !important",
  },
}));
const ButtonDelete = styled("button")((props) => ({
  backgroundColor: "transparent",
  textAlign: "center",
  padding: "15px",
  border: "0px",
  ...(props.deleted === "true"
    ? { color: "#CB8585", pointerEvents: "none" }
    : { color: "#FF0000" }),
  "&:hover": {
    color: "#D0ADAD",
  },
  "&:focus": {
    outline: "0 !important",
  },
}));
const ContainerButtons = styled("div")((props) => ({
  margin: "auto",
  borderRadius: "20px",
  minHeight: "190px",
  background: "#F3F3F3",
  ...(props.deleted === "true" && { pointerEvents: "none" }),
  ["@media (min-width:1240px)"]: {
    minHeight: "190px",
  },
  ["@media (max-width:1239px)"]: {
    minHeight: "170px",
  },
}));
const DeleteSx = {
  fontSize: "100px",
  ["@media (max-width:390px)"]: {
    fontSize: "80px",
  },
};

export {
  Container,
  ContainerButtons,
  Column,
  NonContacts,
  Field,
  FieldInfo,
  Button,
  ButtonDelete,
  DeleteSx,
};
